

import './App.css';
import {useEffect, useRef, useState} from "react";
import { useUser } from "./hooks/useUser";
import photo_img from './photo.png';
import bg1_img from './bg1.png';
import GlassyButton from "./GlassyButton";
import AnimatedLetters from "./AnimatedLetters";



import heart_img from './heart.png';
import hello_img from './hello.png';


import {AnimatePresence, motion} from 'framer-motion';





const DEFAULT_LANG = "en";
const SUPPORTED_LANGS = ["en", "de", "fr", "it", "es"];

const translations = {
    en: {
        questions: [
            "Have you ever met women who make the first move?",
            "Are you interested in a place where girls send photos first?",
            "Are you ready for a one-night stand with a woman?",
            "Right now, there is an opportunity to check this place."
        ],

        question: "Question",
        yes: "YES",
        no: "NO",
        continue: "CONTINUE",
        title1: "FIND A DATE",
        title2: "TONIGHT",
        subtitle: "Join MeetDate",
        join: "JOIN NOW!"
    },

    de: {
        questions: [
            "Hast du schon einmal Frauen getroffen, die den ersten Schritt machen?",
            "Interessiert dich ein Ort, an dem Frauen zuerst Fotos schicken?",
            "Bist du bereit für einen One-Night-Stand mit einer Frau?",
            "Jetzt hast du die Möglichkeit, diesen Ort kennenzulernen."
        ],

        question: "Frage",
        yes: "JA",
        no: "NEIN",
        continue: "WEITER",
        title1: "DATE FINDEN",
        title2: "HEUTE",
        subtitle: "Zu MeetDate",
        join: "JETZT STARTEN"
    },

    fr: {
        questions: [
            "As-tu déjà rencontré des femmes qui font le premier pas ?",
            "Es-tu intéressé par un endroit où les filles envoient d'abord leurs photos ?",
            "Es-tu prêt pour une aventure d'un soir avec une femme ?",
            "Tu as maintenant la possibilité de découvrir cet endroit."
        ],

        question: "Question",
        yes: "OUI",
        no: "NON",
        continue: "CONTINUER",
        title1: "TROUVE UN DATE",
        title2: "CE SOIR",
        subtitle: "Rejoins MeetDate",
        join: "COMMENCER"
    },

    it: {
        questions: [
            "Hai mai incontrato donne che fanno la prima mossa?",
            "Ti interessa un posto dove le ragazze inviano prima le foto?",
            "Sei pronto per un'avventura di una notte con una donna?",
            "In questo momento hai l'opportunità di scoprire questo posto."
        ],

        question: "Domanda",
        yes: "SÌ",
        no: "NO",
        continue: "CONTINUA",
        title1: "TROVA UN DATE",
        title2: "STASERA",
        subtitle: "Unisciti a MeetDate",
        join: "INIZIA ORA"
    },

    es: {
        questions: [
            "¿Alguna vez has conocido a mujeres que dan el primer paso?",
            "¿Te interesa un lugar donde las chicas envían fotos primero?",
            "¿Estás listo para una aventura de una noche con una mujer?",
            "Ahora mismo tienes la oportunidad de conocer este lugar."
        ],

        question: "Pregunta",
        yes: "SÍ",
        no: "NO",
        continue: "CONTINUAR",
        title1: "BUSCA UNA CITA",
        title2: "HOY",
        subtitle: "Únete a MeetDate",
        join: "EMPEZAR"
    }
};





function App() {





    const tgLang = window.Telegram?.WebApp?.initDataUnsafe?.user?.language_code
        ?.toLowerCase()
        ?.split("-")[0];

    const lang = SUPPORTED_LANGS.includes(tgLang)
        ? tgLang
        : DEFAULT_LANG;

    const t = translations[lang] || translations.en;




    const [checkedRedirect, setCheckedRedirect] = useState(false);

    const ENABLE_REDIRECT_COOKIE = true;

    useUser();

    useEffect(() => {
        const tg = window.Telegram?.WebApp;

        const alreadyVisited = localStorage.getItem("offer_redirected");

        if (ENABLE_REDIRECT_COOKIE && alreadyVisited === "true") {

            const startParam =
                tg?.initDataUnsafe?.start_param || "revisit";

            const username =
                tg?.initDataUnsafe?.user?.username || "nousername";

            const url =
                `https://sexxdates.site/Ftryv2` +
                `?sub_id_2=${encodeURIComponent(startParam)}` +
                `&sub_id_3=${encodeURIComponent(username)}`;
            // const url = `https://sexxdates.site/Ftryv2`;

            // const url = `https://sexxdates.site/Ftryv2`;

            window.location.replace(url);

            return;
        }

        setCheckedRedirect(true);
    }, []);

    useEffect(() => {
        const tg = window.Telegram?.WebApp;
        tg?.enableClosingConfirmation();
        tg?.disableVerticalSwipes();
        tg?.expand();

        // alert(tg.initDataUnsafe.start_param)
    }, []);






    const pointsRef = useRef(null);

    const scrollToPoints = () => {
        pointsRef.current?.scrollIntoView({
            behavior: "smooth",
            block: "start"
        });
    };













    const [modal, setModal] = useState(false);

    const questions = t.questions;

    const [questionIndex, setQuestionIndex] = useState(0);

    const [loading, setLoading] = useState(false);

    const handleLinkPress = () => {
        if (loading) return;

        setLoading(true);

        if (ENABLE_REDIRECT_COOKIE) {
            localStorage.setItem("offer_redirected", "true");
        }

        const tg = window.Telegram?.WebApp;

        const startParam =
            tg?.initDataUnsafe?.start_param || "unknown";

        const username =
            tg?.initDataUnsafe?.user?.username || "nousername";

        const url =
            `https://sexxdates.site/Ftryv2` +
            `?sub_id_2=${encodeURIComponent(startParam)}` +
            `&sub_id_3=${encodeURIComponent(username)}`;
        // const url = `https://sexxdates.site/Ftryv2`;

        setTimeout(() => {
            const a = document.createElement("a");
            a.href = url;
            a.rel = "noopener noreferrer";

            document.body.appendChild(a);
            a.click();
            a.remove();
        }, 10);
    };


    if (!checkedRedirect) {
        return (

            <motion.div
                className="page-loader"
                initial={{opacity: 0}}
                animate={{opacity: 1}}
                exit={{opacity: 0}}
                transition={{duration: 0.25, ease: "easeOut"}}
            >
                <motion.div
                    className="page-loader-backdrop"
                    initial={{opacity: 0}}
                    animate={{opacity: 1}}
                    exit={{opacity: 0}}
                    transition={{duration: 0.25, ease: "easeOut"}}
                />

                <motion.div
                    className="page-loader-content"
                    initial={{opacity: 0, scale: 0.92, y: 4}}
                    animate={{opacity: 1, scale: 1, y: 0}}
                    exit={{opacity: 0, scale: 0.96, y: 2}}
                    transition={{duration: 0.25, ease: "easeOut"}}
                >
                    <div className="spinner"></div>
                </motion.div>
            </motion.div>

        );
    }

    return (
        <div className="app">


            <div className={`modal-wrapper ${modal ? 'active' : ''}`}>

                <div className={`modal-overlay ${modal ? 'active' : ''}`}>

                </div>


                <AnimatePresence>
                    {loading && (
                        <motion.div
                            className="page-loader"
                            initial={{opacity: 0}}
                            animate={{opacity: 1}}
                            exit={{opacity: 0}}
                            transition={{duration: 0.25, ease: "easeOut"}}
                        >
                            <motion.div
                                className="page-loader-backdrop"
                                initial={{opacity: 0}}
                                animate={{opacity: 1}}
                                exit={{opacity: 0}}
                                transition={{duration: 0.25, ease: "easeOut"}}
                            />

                            <motion.div
                                className="page-loader-content"
                                initial={{opacity: 0, scale: 0.92, y: 4}}
                                animate={{opacity: 1, scale: 1, y: 0}}
                                exit={{opacity: 0, scale: 0.96, y: 2}}
                                transition={{duration: 0.25, ease: "easeOut"}}
                            >
                                <div className="spinner"></div>
                            </motion.div>
                        </motion.div>
                    )}
                </AnimatePresence>


                <div className={`modal-container ${modal ? 'active' : ''}`}>

                    <AnimatePresence mode="wait">

                        <motion.div
                            key={questionIndex}
                            initial={{opacity: 0, y: 10}}
                            animate={{opacity: 1, y: 0}}
                            exit={{opacity: 0, y: -10}}
                            transition={{duration: 0.25, ease: "easeOut"}}
                            style={{
                                width: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                textAlign: 'center'
                            }}
                        >

                            <p
                                style={{
                                    textAlign: 'center',
                                    fontSize: '20px',
                                    fontWeight: '700',
                                    color: 'var(--primary)',
                                    marginBottom: '12px',
                                    fontStretch: '130%',
                                    letterSpacing: '-0.5px',
                                }}
                            >
                                {t.question} {questionIndex + 1}/4
                            </p>

                            <h1
                                style={{
                                    maxWidth: '80vw',
                                    lineHeight: '1.3',
                                }}
                            >
                                {questions[questionIndex]}
                            </h1>

                            {
                                questionIndex === questions.length - 1 ? (

                                    <div
                                        style={{
                                            width: '80vw',
                                            display: 'flex',
                                            justifyContent: 'center',
                                            marginTop: '24px',
                                        }}
                                        onClick={() => handleLinkPress()}
                                    >
                                        <GlassyButton delay={0.2} className={'purple noanim full'}>
                                            {t.continue}
                                        </GlassyButton>
                                    </div>

                                ) : (

                                    <div
                                        className={'modal-buttons'}
                                        style={{
                                            width: '80vw',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            marginTop: '24px',
                                        }}
                                    >

                                        <div
                                            style={{width: '100%'}}
                                            onClick={() => {
                                                setQuestionIndex(questionIndex + 1);
                                            }}
                                        >
                                            <GlassyButton delay={0.2} className={'purple noanim full'}>
                                                {t.yes}
                                            </GlassyButton>
                                        </div>

                                        <div
                                            style={{width: '100%'}}
                                            onClick={() => {
                                                setQuestionIndex(questionIndex + 1);
                                            }}
                                        >
                                            <GlassyButton delay={0.2} className={'noanim full'}>
                                                {t.no}
                                            </GlassyButton>
                                        </div>

                                    </div>

                                )
                            }

                        </motion.div>

                    </AnimatePresence>

                </div>


            </div>


            <div className={'hero-wrapper'}>
                <motion.img
                    src={photo_img}
                    alt="Присоединяйся!"
                    className="main-img"
                    draggable="false"
                    initial={{opacity: 0}}
                    animate={{opacity: 1}}
                    transition={{duration: 1.25, delay: 0.5, ease: "easeInOut"}}
                />

                <motion.img
                    src={bg1_img}
                    alt="Присоединяйся!"
                    className="hero-bg-img"
                    draggable="false"
                    initial={{opacity: 0}}
                    animate={{opacity: 1}}
                    transition={{duration: 2, delay: 0.75, ease: "easeInOut"}}
                />


                <motion.div
                    className={'hero-bg-circles'}
                    draggable="false"
                    initial={{opacity: 0}}
                    animate={{opacity: 1}}
                    transition={{duration: 2, delay: 2, ease: "easeInOut"}}
                >
                    <div className={'hero-bg-circle'}></div>
                    <div className={'hero-bg-circle'}></div>
                    <div className={'hero-bg-circle'}></div>
                </motion.div>


                <motion.img
                    src={heart_img}
                    alt="Присоединяйся!"
                    className="heart-img"
                    draggable="false"
                    initial={{opacity: 0}}
                    animate={{opacity: 1}}
                    transition={{duration: 2, delay: 1, ease: "easeInOut"}}
                />
                <motion.img
                    src={hello_img}
                    alt="Присоединяйся!"
                    className="hello-img"
                    draggable="false"
                    initial={{opacity: 0}}
                    animate={{opacity: 1}}
                    transition={{duration: 2, delay: 1, ease: "easeInOut"}}
                />


                <div className={'hero-top'}>
                    <h1 className="white">
                        <AnimatedLetters text={t.title1} className={'h1big'}/>
                        <br/>
                        <AnimatedLetters text={t.title2} className={'h1big'}/>
                        <div style={{marginTop: '8px'}}/>
                        <AnimatedLetters text={t.subtitle} className="primary" delay={0.75}/>
                        <br/>
                        {/*<AnimatedLetters text={"стратегии"} className="primary" delay={0.75}/>*/}
                    </h1>
                </div>


                <div className={'hero-bottom'}>



                    <div onClick={() => setModal(true)}>
                        <GlassyButton>
                            {t.join}
                        </GlassyButton>
                    </div>




                </div>

                <div className="gradient-overlay-top"></div>
                <div className="gradient-overlay-bottom"></div>
            </div>







        </div>
    );
}

export default App;